import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchLeadStoryData = args => {
    return doDefaultFetch(
        `/site/api/leadStory` +
        `?sort=publishDate` +
        `&dir=DESC` +
        `&exclude=siteVersion`,
        args
    );
};

export default {
    fetchLeadStoryData
};
